import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import type { IDiagnosticsRoadMeasureResults } from "../../../models/storeModels/IDiagnosticsRoadMeasureResults";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { logout } from "../../../features/auth";

function getInitialState(){
    const initialState: IDiagnosticsRoadMeasureResults = {
        period: getItemWebStorage('diagnosticsYearFilters')?.roadMeasureResults ?? `${new Date().getFullYear()}`,
        type: getItemWebStorage('diagnosticsYearFilters')?.roadMeasureResultsType ?? 'single',
        measureTypeId: null,
        hasChosenYear: false
    }
    return initialState;
}



export const diagnosticsRoadMeasureResultsSlice = createSlice({
    name: 'diagnosticsRoadMeasureResults',
    initialState: getInitialState(),
    reducers: {
        setPeriodRoadMeasureResults(state, action: PayloadAction<any>) {
            state.period = action.payload
        },
        setType(state, action: PayloadAction<any>) {
            state.type = action.payload
        },
        setHasChosenYear(state, action: PayloadAction<any>) {
            state.hasChosenYear = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setPeriodRoadMeasureResults, setType, setHasChosenYear } = diagnosticsRoadMeasureResultsSlice.actions
export const diagnosticsRoadMeasureResultsReducer = diagnosticsRoadMeasureResultsSlice.reducer;
